export default [
  {
    path: '/pay',
    name: 'pay',
    component: () => {
      return import('@/views/cashierdesk/pay')
    }
  },
  {
    path: '/pay/',
    name: 'layout',
    component: () => {
      return import(
        /* webpackChunkName: "cashierdesk" */ '@/views/cashierdesk/layout'
      )
    },
    children: [
      {
        path: 'addBankCard',
        name: 'addBankCard',
        component: () => {
          return import(
            /* webpackChunkName: "cashierdesk" */ '@/views/cashierdesk/addBankCard'
          )
        }
      },
      {
        path: 'bankList',
        name: 'bankList',
        component: () => {
          return import(
            /* webpackChunkName: "cashierdesk" */ '@/views/cashierdesk/bankList'
          )
        }
      }
    ]
  }
]
